import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { ChevronLeft } from '@mui/icons-material';

import { Button } from '../../../../../../common/components/Button/Button';
import { Toolbar } from '../../../../../../common/components/Toolbar/Toolbar';
import Menu from '../../../../../../common/components/Menu/Menu';
import { MenuItem } from '../../../../../../common/components/MenuItem/MenuItem';
import { isMobile } from '../../../../../../common/services/isMobile';

export const titleStyle = {
  fontWeight: 700,
  margin: 0,
  fontSize: '20px',
};

function DemoEdgeControllerDetailsToolbar({
  edgeControllerId: edgeControllerIdProp = null,
  isFetching = false,
  pristine = true,
  submitting = false,
  readOnly = true,
  submit,
  backButtonHandler,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);

  const { edgeControllerId: urlEdgeControllerId } = useParams();
  const edgeControllerId = edgeControllerIdProp || urlEdgeControllerId;
  const title = edgeControllerId;

  const handleSave = () => {
    if (!isFetching && !pristine && !submitting) {
      submit();
    }
  };

  const handleReboot = () => {
    // TODO: Implement reboot functionality
    console.log('Reboot edge controller:', edgeControllerId);
  };

  const handleSyncWithCloud = () => {
    // TODO: Implement sync with cloud functionality
    console.log('Sync with cloud:', edgeControllerId);
  };

  const handleRemoteAccess = () => {
    // TODO: Implement remote access functionality
    console.log('Remote access to edge controller:', edgeControllerId);
  };

  const handleAssignToPlaza = () => {
    // TODO: Implement assign to plaza functionality
    console.log('Assign to plaza:', edgeControllerId);
  };

  const handleMoveToCustomer = () => {
    // TODO: Implement move to customer functionality
    console.log('Move to customer:', edgeControllerId);
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Toolbar>
      <div className="edge-controller-toolbar">
        <Button variant="contained" color="secondary" onClick={backButtonHandler} startIcon={<ChevronLeft />} disabled={isFetching}>
          Back
        </Button>
        <div className="toolbar-separator" />
        <h2 style={titleStyle}>{title}</h2>
        <div className="toolbar-separator" />
        <div className="edge-controller-toolbar__actions">
          {!isMobile && (
            <>
              <Button variant="contained" color="secondary" onClick={handleReboot} disabled={isFetching}>
                Reboot
              </Button>
              <Button variant="contained" color="secondary" onClick={handleSyncWithCloud} disabled={isFetching}>
                Sync with Cloud
              </Button>
              <Button variant="contained" color="secondary" onClick={handleRemoteAccess} disabled={isFetching}>
                Remote Access
              </Button>
              <Button variant="contained" color="secondary" onClick={handleAssignToPlaza} disabled={isFetching}>
                Assign to Plaza
              </Button>
              <Button variant="contained" color="secondary" onClick={handleMoveToCustomer} disabled={isFetching}>
                Move to Customer
              </Button>
            </>
          )}

          {isMobile && (
            <>
              <Button variant="contained" color="secondary" onClick={handleMenuOpen} disabled={isFetching}>
                Actions
              </Button>
              <Menu anchorEl={anchorEl} open={menuOpen} onClose={handleMenuClose}>
                <MenuItem
                  onClick={() => {
                    handleReboot();
                    handleMenuClose();
                  }}
                >
                  Reboot
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleSyncWithCloud();
                    handleMenuClose();
                  }}
                >
                  Sync with Cloud
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleRemoteAccess();
                    handleMenuClose();
                  }}
                >
                  Remote Access
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleAssignToPlaza();
                    handleMenuClose();
                  }}
                >
                  Assign to Plaza
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleMoveToCustomer();
                    handleMenuClose();
                  }}
                >
                  Move to Customer
                </MenuItem>
              </Menu>
            </>
          )}

          {!readOnly && (
            <Button color="primary" onClick={handleSave} disabled={pristine || submitting || isFetching}>
              Submit Changes
            </Button>
          )}
        </div>
      </div>
    </Toolbar>
  );
}

export default DemoEdgeControllerDetailsToolbar;
